import type { ReactNode } from 'react';
import type { MetadataItem } from './tool-config-types';

export type ToolHarSummary = {
  count: number;
  duration: number;
};

export function buildToolHeaderMetadata({
  credentialPreview,
  credentialIcon,
  metadata,
  harSummary,
}: {
  credentialPreview?: { username: string; role: string };
  credentialIcon?: ReactNode;
  metadata: MetadataItem[];
  harSummary: ToolHarSummary | null;
}): MetadataItem[] {
  const headerMetadata: MetadataItem[] = [];

  if (credentialPreview) {
    headerMetadata.push({
      label: 'User',
      value: `${credentialPreview.username} (${credentialPreview.role})`,
      icon: credentialIcon,
    });
  }

  headerMetadata.push(...metadata);

  if (harSummary) {
    headerMetadata.push({
      label: 'HTTP',
      value: `${harSummary.count} req${harSummary.count === 1 ? '' : 's'}`,
    });
    headerMetadata.push({
      label: 'Duration',
      value: `${Math.round(harSummary.duration)}ms`,
    });
  }

  return headerMetadata;
}
